import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoundedButton from '@components/RoundedButton';

import type { DiagnosticReportRecord } from '@models/diagnostic-report';

import { usePostPacsStudiesMutation } from 'generated/diagnostic-report.generated';
import type { PacsStudyInput } from 'generated/types';

import FileDropzone from './DicomFileDropzone';
import ImagingStudyList from './DicomImageList';

const messages = defineMessages({
  manageImages: {
    id: 'dicomImageManager.manageImages',
    defaultMessage: 'Manage DICOM Images',
  },
});

interface DicomImageManagerProps {
  diagnostic_report: DiagnosticReportRecord;
}

const DicomImageManager = ({ diagnostic_report }: DicomImageManagerProps) => {
  const { formatMessage } = useIntl();
  const [open, setOpen] = React.useState(false);
  const [postPacsStudies] = usePostPacsStudiesMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleStudiesUploaded = async (studies: PacsStudyInput[]) => {
    if (diagnostic_report.id && studies.length) {
      // Update diagnostic report (mark upload as completed)
      await postPacsStudies({
        variables: {
          input: {
            diagnostic_report_id: diagnostic_report.id,
            pacs_studies: studies,
          },
        },
      });
    }
    handleClose();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  React.useEffect(() => {
    return () => {
      setOpen(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <RoundedButton onClick={handleOpen}>
        {formatMessage(messages.manageImages)}
      </RoundedButton>
      <Dialog maxWidth="xl" onClose={handleClose} open={open}>
        <DialogContent>
          <ImagingStudyList diagnosticReport={diagnostic_report} />
          <FileDropzone
            diagnostic_report_id={diagnostic_report.getId()}
            onComplete={handleStudiesUploaded}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DicomImageManager;
